import {makePostReq} from "@/store/helpers/request";
import {appConfig} from "@/lib/appConfig";

export const uploadFile = async (data) => await makePostReq(`${appConfig.domain}/file`, data);
